/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialAnalyticsDashboardCategoriesResponse } from '../../models/editorial-analytics-dashboard-categories-response';

export interface GetEditorialAnalyticsDashboardCategories$Params {
  companyId?: number;
}

export function getEditorialAnalyticsDashboardCategories(http: HttpClient, rootUrl: string, params?: GetEditorialAnalyticsDashboardCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsDashboardCategoriesResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialAnalyticsDashboardCategories.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialAnalyticsDashboardCategoriesResponse>;
    })
  );
}

getEditorialAnalyticsDashboardCategories.PATH = '/api/editorial/analytics/dashboard-categories';
